<template>
  <div class="CompanyAuthorizedScope">
    <div class="authorized-scope">
      <div class="inner_center">
        <h2>授权范围详情</h2>
        <div class="members-package">
          <!--          <i class="icon_vip-member"/>-->
          <div class="authorization-scoped-wrap">
            <!-- 授权范围 -->
            <div class="authorization-scoped">
              授权范围
            </div>
            <!-- 权益保障 -->
            <div
              v-for="vo in COMPANY_AUTHORIZED_SCOPE"
              :key=" 'interestsParent' + vo.label "
              class="rights-and-interests authorization-item"
            >
              <!--              <div class="title">{{ vo.label }}</div>-->
              <ul>
                <li
                  v-for="item in vo.list"
                  :class=" { 'NO': !item.value } "
                  :key=" 'interests' + item.label ">
                  <div
                    class="name"
                  >
                    {{ item.label }}
                    <span v-if="item.value && item.value.length > 3">：{{ item.value }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="member-package-item-wrap">

            <div class="member-package-item-hidden">
              <div class="member-package-item"
                   :style="[{left: isShowCustom ? '-186px': 0 },]"
              >
                <div
                  v-for="(v,i) in INTRO_COMPANY.VIP_CARD_LIST"
                  :key="i"
                  class="package-person package-item"
                  :class="'card-header' + (i+1)"
                >
                  <div class="title">
                    <i class="icon_custom"></i>
                    <template v-if="v.ID != -999">
                      <div class="name">{{ v.LABEL }}</div>
                      <div class="price __price-wrap">
                        <span class="text-dollar">￥</span>
                        <span class="text-price">{{ v.PRICE }}</span>
                        <span class="text-year">/年</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="name name-custom">定制版</div>
                    </template>
                    <div
                      class="buy-btn"
                      @click="buy(v)">
                      {{ v.ID != -999 ? '立即购买' : '在线咨询' }}
                    </div>
                  </div>
                  <ul>
                    <li
                      v-for="(vo,idx) in v.interestList"
                      :key="'package1'+idx"
                      :class="[

                  ]"
                    >
<!--                      {{ idx+1 }}-->
                      <i
                        v-if=" vo === 0 || vo === 1"
                        class="iconfont"
                        :class="[ vo === 0 ? 'icon-cha2': 'icon-gou' ]">
                      </i>
                      <span v-else>
                        <span class="color-blue"
                              v-html="vo"
                              v-if="(i == 4 && idx == 1) || idx == 3"
                        ></span>
                        <span  v-else-if="vo == '永久' && idx == 8">
                          <span  v-html="vo"></span>
                          <i
                            class="iconfont icon-question"
                          >
                            <div
                              class="hover-box"
                            >
                              会员期间下载制作完成且公开发表的作品可在授权范围内永久授权
                            </div>
                          </i>
                        </span>
                        <span v-else v-html="vo"></span>


                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>


            <div class="custom-bar _hide" @click="isShowCustom = !isShowCustom">
              <span>{{ isShowCustom ? '收起定制版' : '查看定制版' }}</span>
              <i class="iconfont icon-a-topright"/>
            </div>
          </div>
        </div>
      </div>

      <div class="service-box">
        以上授权范围不满足您的需求，请联系

        <a :href="PAGE_LINK.SERVICE" target="_blank" class="service">
          <i class="iconfont icon-kefu"/>
          企业客服
        </a>
      </div>
    </div>


  </div>
</template>

<script>
import {info} from "@/components/member/common/module";
import {
  BUSINESS_VIP_INFO, PERSON_VIP_INFO,
  PERSON_QUARTER_MONTH_INFO, BUSINESS_VIP_MONTH_INFO
} from "@/constant/VIP";
import {COMPANY_All_PURPOSE, COMPANY_AUTHORIZED_SCOPE, COMPANY_ONLINE} from "@/constant/VIP_COMPANY";
import {serviceLink} from "@/constant/CONFIG";
import {PAGE_LINK} from "@/constant/PAGE_PATH";
import {INTRO_COMPANY} from "@/constant/intro/INTRO_COMPANY";

// 线上用途 权益
const COMPANY_ONLINE_INTERESTS = ['', '1家', '1个', '￥1,000', '「线上用途」商用授权书', '海量下载', '全球', '永久', 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1]
// 线上线下全用途 权益
const COMPANY_All_PURPOSE_INTERESTS = ['', '1个', '1个', '￥5,000', '「全用途」商用授权书', '海量下载', '全球', '永久', 1, 1, 1, 1, 1, 1, 1, '限5万份', '限10万份', 0, 1, 0, 0, 0, 0, 0, 1, 1]
// 企业定值 权益
const COMPANY_CUSTOM_INTERESTS = ['', '1家起（可加购）', '1个起（可加购）', '￥5,000/家', '「定制版」商用授权书', '海量下载', '全球', '永久', 1, 1, 1, 1, 1, 1, 1, '限5万份', '限10万份', 0, 1, 0, 0, 0, 0, 0, 1, 1]


export default {
  name: "CompanyAuthorizedScope",
  data() {
    return {
      info,
      BUSINESS_VIP_INFO, PERSON_VIP_INFO,
      PERSON_QUARTER_MONTH_INFO,
      BUSINESS_VIP_MONTH_INFO,

      COMPANY_AUTHORIZED_SCOPE,
      COMPANY_ONLINE,
      COMPANY_All_PURPOSE,

      COMPANY_ONLINE_INTERESTS,
      COMPANY_All_PURPOSE_INTERESTS,
      COMPANY_CUSTOM_INTERESTS,

      serviceLink,
      PAGE_LINK,


      INTRO_COMPANY,
      isShowCustom: false,  // 是否显示定制版

    }
  },
  watch: {
    isShowCustom: {
      handler(n) {
        if (n == true) {
          console.log('1111')
        } else {
          console.log('22222')

        }
      }
    }
  },
  methods: {
    buy(vipInfo) {
      this.$emit('buy', vipInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.authorized-scope {
  //height: 1783px;
  //height: 1439px;
  background: #F5F6FA;
  padding: 56px 0 50px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #FFFFFF 0%, #F5F6FA 15%, #F5F6FA 100%);

  .inner_center {
    width: 1248px !important;
    //width: 1019px !important;
    overflow: hidden;
  }

  h2 {
    font-size: 36px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 48px;
    letter-spacing: 1px;
    //margin-bottom: 160px;
    text-align: center;
  }

  .members-package {
    margin-top: 120px;
    display: flex;
    border-radius: 20px;
    border: 1px solid #ECEFF6;
    //overflow: hidden;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 26, 0.06);
    //margin: -114px auto 80px;
    width: 1200px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;

    .icon_vip-member {
      @include BgImage(554px, 119px, 'introduce/icon_vip-member.png');
      @include Position(1, 5, 56px, -84px);
      z-index: 2;
    }

    .authorization-scoped-wrap {
      width: 275px;
      flex-shrink: 0;
      /* 抽离公共代码 */
      .authorization-item {
        display: flex;
        //border: 1px solid #ECEFF6;
        border-left: 0;
        box-sizing: border-box;
        border-top: 0;
        position: relative;
        z-index: 5;

        .title {
          width: 170px;
          border-right: 1px solid #ECEFF6;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: rgba(66, 72, 102, 0.85);
          text-align: center;
          font-size: 17px;
        }

        ul {
          flex: 1;

          li {
            //height: 84px;
            //height: 80px;
            padding: 19px 16px 20px 26px;
            box-sizing: border-box;
            border-bottom: 1px solid #ECEFF6;
            border-right: 1px solid #ECEFF6;
            display: flex;
            //align-items: center;
            justify-content: center;
            flex-direction: column;

            &:first-child {
              background: rgba(255, 237, 217, 1);
              height: 57px;

              .name {
                font-size: 14px;
                font-weight: bold;
                color: #2D2B33;
              }
            }

            &:last-child {
              //border-bottom: 0;
            }

            &.NO {
              height: 57px;

              .name {
                margin-bottom: 0px;
              }
            }

            &:nth-child(1),
              //&:nth-child(11),
            &:nth-child(13),
            &:nth-child(17),
            &:nth-child(19),
            &:nth-child(21),
            &:nth-child(23),
            &:nth-child(25),
            &:nth-child(27),
            &:nth-child(29),
            &:nth-child(31),
            {
              border-right: none;
              border-bottom: none;
              margin-top: -1px;
            }


            &:nth-child(1) {

            }

            .name {
              font-size: 13px;
              color: #424866;
              line-height: 17px;
            }

            .desc {
              //color: #424866;
              //line-height: 19px;
              //font-size: 13px;
            }
          }
        }

        &:last-child {
          border-bottom: 0;
        }
      }

      .authorization-scoped {
        height: 77px;
        line-height: 77px;
        box-sizing: border-box;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        color: #424866;
        //border-bottom: 1px solid #ECEFF6;
        //border-right: 1px solid #ECEFF6;
        position: relative;
        z-index: 5;
        background-color: #FFFFFF;
        border-radius: 20px 0 0 0;
      }
    }

    .member-package-item-wrap {
      margin-top: -65px;
      border-radius: 20px 0 0 0;
      width: 930px;
      position: relative;

      .member-package-item-hidden {
        width: 100%;
        height: 100%;
        border-radius: 20px 0 0 0;
        //overflow: hidden;
        position: relative;
      }

      .custom-bar {
        width: 48px;
        background: linear-gradient(180deg, #FFD3A3 0%, #FFDFB3 100%);
        border-radius: 0px 20px 20px 0px;
        @include Position(1, 2, -48px, 3px);
        bottom: 0;
        padding-top: 210px;
        text-align: center;
        //height: 95px;
        font-size: 14px;
        font-weight: bold;
        color: #733D15;
        line-height: 19px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        span {
          display: inline-block;
          width: 15px;
          line-height: 19px;
          margin-bottom: 6px;
        }
      }
    }

    .member-package-item {
      @include Position(1, 5, 0, 0);
      display: flex;
      //position: relative;
      //top: -97px;
      //z-index: 10;
      //margin-top: -97px;
      background-color: #fff;
      border-radius: 20px 0 0 0;
      //overflow: hidden;
      border-top: 1px solid #ECEFF6;
      //border: 1px solid #ECEFF6;
      //border-bottom: none;
      transition: all 0.5s ease-in-out;

      .package-item {
        width: 186px;
        flex-shrink: 0;

        .title {
          height: 141px;
          box-sizing: border-box;
          //border-right: 1px solid #ECEFF6;
          border-left: 1px solid #ECEFF6;
          position: relative;

          @include LayoutFlex(2);

          .icon-prefs {
            @include Position(1, 5, 0, 0);
            width: 124px;
            height: 28px;
            background: linear-gradient(90deg, #FFD16C 0%, #FFAD63 100%);
            border-radius: 20px 0px 8px 0px;
            color: #FFFFFF;
            line-height: 28px;
            display: flex;
            align-items: center;
            font-size: 0;

            .icon_prefs {
              @include BgImage(15px, 15px, 'member/icon_prefs.png');
              margin: 0 4px 0 15px;

            }

            .icon-prefs-txt {
              font-size: 13px;
            }
          }

          .name {
            font-weight: bold;
            color: #0A2540;
            font-size: 16px;
            line-height: 21px;
            letter-spacing: 1px;

            &.name-custom {
              font-size: 16px;
              font-weight: bold;
              color: #233E90;
              line-height: 21px;
              letter-spacing: 1px;
              margin-bottom: 24px;
              padding-top: 18px;
            }
          }

          .__price-wrap {
            font-size: 0;
            //margin: 8px 0 10px 0;
            margin: 2px 0;
            color: #596088;
            font-weight: bold;

            .text-dollar {
              font-size: 18px;
              line-height: 24px;
              color: #2D2B33;
              vertical-align: 2px;

            }

            .text-price {
              //letter-spacing: 1px;
              //margin: 0 4px;
              margin-left: 4px;

              font-size: 28px;
              font-weight: bold;
              color: #2D2B33;
              line-height: 42px;
            }

            .text-year {
              font-size: 18px;
              line-height: 24px;
              color: #2D2B33;
            }
          }

          .buy-btn {
            width: 132px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s ease-in;
            //background: #35D0BA;
            background: #FF5758;
            border-radius: 22px;
            font-size: 13px;
            font-weight: bold;
            color: #FFFFFF;
            @include ElementHover('', #FF6869);
          }

        }

        ul {

          li {
            height: 57px;
            box-sizing: border-box;
            border-bottom: 1px solid #ECEFF6;
            border-right: 1px solid #ECEFF6;
            @include LayoutFlex(1);


            &:nth-child(1) {
              background: pink;
              font-size: 30px;
            }

            &:nth-child(2) {
            }

            &:nth-child(3) {
            }

            &:nth-child(4) {
            }

            &:nth-child(5) {
            }

            &:nth-child(6) {
            }

            &:nth-child(7) {
            }

            &:nth-child(8) {
            }

            &:nth-child(9) {
            }

            &:nth-child(10) {
            }

            &:nth-child(11) {
            }


            &:nth-child(13) {
              //height: 256px;
              height: 74px;
            }
            &:nth-child(14) {
              //height: 256px;
              height: 91px;
            }

            &:nth-child(15) {
              height: 256px;
              height: 91px;
            }

            &:nth-child(17) {
              height: 74px;
              height: 256px;
            }

            &:nth-child(18) {
              height: 57px;
            }
            &:nth-child(19) {
              height: 74px;
            }


            &:nth-child(20) {
              height: 91px;
            }
            &:nth-child(21) {
              //height: 74px;
            }
            &:nth-child(22) {
              height: 74px;
            }

            &:nth-child(23) {
              height: 56px;
            }

            &:nth-child(24) {
              height: 239px;
            }

            &:nth-child(26) {
              height: 91px;
            }
            &:nth-child(28) {
              height: 148px;
            }

            &:nth-child(30) {
            }

            &:nth-child(32) {
              height: 182px;
            }

            &:nth-child(34) {
            }

            &:nth-child(36) {
              height: 74px;
            }
            &:nth-child(37) {
              height: 74px;
            }


            &:nth-child(1),
            &:nth-child(12),
            //&:nth-child(14),
            &:nth-child(16),
            &:nth-child(18),
            &:nth-child(21),
            &:nth-child(23),
            &:nth-child(25),
            &:nth-child(27),
            &:nth-child(29),
            &:nth-child(31),
            &:nth-child(33),
            &:nth-child(35),
            {
              background: #ffedd9;
              border-right: none;
              border-bottom: none;
              margin-top: -1px;
            }


            .iconfont {
              font-size: 22px;
            }

            .icon-gou {
              color: #35D0BA;
            }

            .icon-cha2 {
              color: #A4A9BE;
            }

            &:last-child {
              border-bottom: 0;
            }

            span {
              font-size: 14px;
              color: #2D2B33;
              line-height: 20px;
            }
          }
        }

        &:first-child {
          ul {
            li {
              //border-right: 1px solid #ECEFF6;
            }
          }
        }

        &:last-child {
          li {
            border-right: none;
          }

          .title {
            border-right: 0;
            //width: 261px;
            //background-color: #FFFFFF;
            position: relative;

            &:after {
              /*content: '';
              width: 10px;
              @include Position(1, 2, -1px, 0);
              bottom: 0;
              background-color: #FFFFFF;
              border-radius: 20px 20px 0px 0px;*/
            }
          }
        }

      }

      .card-header5 {

        .title {
          background: linear-gradient(180deg, #FFEEC3 0%, #FFD489 100%);
          position: relative;

          .icon_custom {
            @include BgImage2(242px, 180px, 'introduce/company/icon_custom.png');
            position: absolute;
            top: 0;
            right: 0;

          }

          .name, .buy-btn {
            position: relative;
            z-index: 2;

          }

          .buy-btn {
            border: 2px solid #FFFFFF;
            //line-height: 34px;
            background: linear-gradient(227deg, #FF5C4B 0%, #FF007F 100%) !important;
            box-shadow: 0px 2px 4px 0px rgba(199, 132, 15, 0.17);
            //box-sizing: border-box;
            &:hover {
              background: linear-gradient(227deg, #FF007F 0%, #FF5C4B 100%) !important;
            }
          }


        }
      }
    }
  }
}

.service-box {
  font-size: 14px;
  color: #424866;
  line-height: 19px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 39px;

  .service {
    width: 100px;
    height: 26px;
    border-radius: 13px;
    border: 1px solid #233E90;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    color: #233E90;

    .icon-kefu {
      margin-right: 6px;

    }

    &:hover {
      background: #233E90;
      color: #FFFFFF;
      cursor: pointer;
    }
  }

}

.color-blue {
  color: #0C3DD3 !important;
}

.package-person {
  //background: #35D0BA;
  border-radius: 14px 14px 0px 0px;
  text-align: center;
  color: #FFFFFF;

  @mixin CardHeaderTitle($color: transparentize) {
    color: $color;
    .title, .name {
      color: $color !important;
    }
  }


  &.card-header1 {
    @include CardHeaderTitle(rgba(177, 119, 81, 1))
  }

  &.card-header2 {
    @include CardHeaderTitle(rgba(179, 77, 41, 1))
  }

  &.card-header3 {
    @include CardHeaderTitle(rgba(137, 70, 44, 1))
  }

  &.card-header4 {
    @include CardHeaderTitle(rgba(86, 40, 5, 1))
  }

  &.card-header5 {
    @include CardHeaderTitle(rgba(52, 57, 129, 1));

  }
}


.iconfont {
  font-size: 14px;
  //margin: 0 10px 0 24px;
}

.icon-question {
  //@include Position(1, 2, 12px, 50%);
  //transform: translateY(-50%);
  z-index: 1;
  margin: 0;
  position: relative;
  top: 3px;
  left: -6px;

  &:after {
    content: '';
    display: inline-block;
    padding: 10px;
    @include Position(1, 5, 50%, 50%);
    transform: translate(-50%, -50%);
  }

  &:hover {
    .hover-box {
      display: block;
    }
  }

  .hover-box {
    min-width: 140px;
    //height: 60px;
    background: #424866;
    border-radius: 4px;
    @include Position(1, 5, 24px, 50%);
    transform: translateY(-50%);
    font-size: 12px;
    color: #FFFFFF;
    line-height: 16px;
    padding: 6px 8px;
    display: none;
    text-align: left;

    &:after {
      display: inline-block;
      content: '';
      width: 8px;
      height: 8px;
      background: #424866;
      @include Position(1, 5, -4px, 50%);
      transform: translateY(-50%) rotate(135deg);
    }

    &:before {
      display: inline-block;
      content: '';
      width: 15px;
      height: 100%;
      @include Position(1, 4, -15px, 0);
      //background-color: pink;
    }
  }

  .hover-box2 {
    width: 180px;
  }


}

</style>

